module.exports = __webpack_public_path__ + "img/mobile scanner stand45.67c80bd0.jpg";